module.exports = __webpack_public_path__ + "img/bg-r02.89aff762.jpg";